// generated by genversion
export const version = '2.16.0-rc.5';
